import { useEffect, useRef } from "react";
import { registerPoller, unregisterPoller, POLL_PRIORITY } from "../store/pollScheduler";

export { POLL_PRIORITY };

export function usePoll(
  key: string,
  fetch: () => Promise<unknown>,
  opts?: { priority?: number; enabled?: boolean },
): void {
  const fetchRef = useRef(fetch);
  fetchRef.current = fetch;
  const priority = opts?.priority ?? POLL_PRIORITY.NORMAL;
  const enabled = opts?.enabled ?? true;
  useEffect(() => {
    if (!enabled) return;
    registerPoller({ key, priority, fetch: () => fetchRef.current() });
    return () => unregisterPoller(key);
  }, [key, priority, enabled]);
}
